import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Inject,
    OnDestroy,
    OnInit,
    Optional,
    computed,
    signal,
} from '@angular/core';
import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogContent,
    MatDialogRef,
} from '@angular/material/dialog';
import {
    MessageAction,
    MessageObserverService,
} from '../../../services/message-observer.service';
import { TranslateService } from '@ngx-translate/core';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'tw-dialog-msg',
    templateUrl: './dialog-msg.component.html',
    styleUrls: ['./dialog-msg.component.css'],
    imports: [MatDialogContent, MatDialogActions, MatButton],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogMsgComponent implements OnInit, OnDestroy {
    error = signal<any[]>([]);
    sub = [];
    dataSignal = signal<MessageAction | null>(null);
    message = computed(() => {
        const d = this.dataSignal();
        return d ? this.translate.instant(d.message) : '';
    });

    constructor(
        public dialogRef: MatDialogRef<DialogMsgComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: MessageAction,
        public messageObserverService: MessageObserverService,
        public translate: TranslateService,
        private cdr: ChangeDetectorRef,
    ) {}

    ngOnInit() {
        this.dataSignal.set(this.data);
        this.error.set([]);
        const a = this.messageObserverService
            .watchMessage()
            .subscribe((value) => {
                console.log(value.message);
                if (
                    !value ||
                    !value.dialog ||
                    this.error()?.find(
                        (e) => JSON.stringify(e) === JSON.stringify(value),
                    )
                ) {
                    return;
                }
                this.dataSignal.set(null);
                this.error.update((errors) => [...errors, value]);
                this.dataSignal.set(value);
                this.cdr.markForCheck();
            });
        this.sub.push(a);
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    ngOnDestroy(): void {
        this.sub.forEach((s) => s.unsubscribe());
    }
}
